"use client";
import { useRouter } from "@/i18n/navigation";
import { useEffect, useRef, useState } from "react";
import CommonButton from "@/components/Button/CommonButton";
import { useLoanAmountStore } from "@/store";
import { ROUTES } from "@/constants/routes";
import { useLocale } from "next-intl";
import ButtonRightArrow from "@/assets/iconComponents/ButtonRightArrow";

const LoanCalculator = ({ amount, setAmount, min, max, step, pct, t }) => {
  const currentLocale = useLocale();
  const [locale, setLocale] = useState(currentLocale);
  const updateSelectedLoanAmount = useLoanAmountStore((state) => state.updateSelectedLoanAmount);
  const sliderRef = useRef(null);
  const [dotLeft, setDotLeft] = useState("0px");
  const dotSize = 24; // px

  const router = useRouter();

  const handleButtonClick = () => {
    updateSelectedLoanAmount(amount);
    router.push(ROUTES.ONBOARDING);
  };

  // Update dot position when amount or slider width changes
  useEffect(() => {
    if (!sliderRef.current) return;
    const percent = (amount - min) / (max - min);
    const sliderWidth = sliderRef.current.offsetWidth || 1;
    // Prevent dot from overflowing at the ends
    const pos = percent * (sliderWidth - dotSize) + dotSize / 2;
    setDotLeft(`${pos}px`);
  }, [amount, min, max]);

  useEffect(() => {
    setLocale(locale);
  }, [currentLocale]);

  return (
    <div className="w-full sm:w-[450px] py-6 px-7.5 md:py-10 md:h-full md:w-fit bg-[#EDD2B9]/90 rounded-[20px] sm:rounded-2xl md:rounded-2xl  md:p-9 md:pt-[25px]">
      <div className="flex justify-between flex-col gap-3 sm:gap-4 md:gap-5 h-full">
        <div className="flex flex-col md:flex-row justify-between sm:items-center gap-2 sm:gap-3 lg:gap-10 xl:gap-15 2xl:gap-18">
          <div className="body-copy-big-text text-[#B3594D]">
            <p>{t("home.card_title_1")}</p>
            {/* <p className="text-xl body-copy-small-text">
              {amount.toLocaleString(locale === "sv" ? "sv-SE" : "en-US")}
            </p> */}
          </div>
          <div className="text-center text-[#B3594D] mt-5 sm:mt-0 text-48px-bold">
            <span className="inline-block transition-all duration-200 ease-in-out lg:min-w-[250px] xl:min-w-[270px] 2xl:min-w-[320px] text-center tabular-nums">
              {amount.toLocaleString(locale === "sv" ? "sv-SE" : "en-US")} kr
            </span>
          </div>
        </div>
        <div>
          <div className="relative w-full h-[1px]">
            <input
              ref={sliderRef}
              type="range"
              min={min}
              max={max}
              step={step}
              value={amount}
              onChange={(e) => setAmount(+e.target.value)}
              className="absolute inset-0 w-full h-full appearance-none cursor-pointer bg-transparent custom-slider"
              style={{
                background: `linear-gradient(to right,#B3594D 0%,#B3594D ${pct}%,#E5E7EB ${pct}%,#E5E7EB 100%)`
              }}
            />
            {/* Moving red dot */}
            <div
              className="absolute top-1/2 transform -translate-y-1/2 pointer-events-none"
              style={{
                left: dotLeft,
                width: dotSize,
                height: dotSize,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "left 0.1s"
              }}
            >
              <div
                className="rounded-full p-2 shadow-lg"
                style={{ width: dotSize - 8, height: dotSize - 8 }}
              />
            </div>
          </div>
          <div className="flex justify-between body-copy-small-text text-[#B3594D] mt-2">
            <span>{min.toLocaleString(locale === "sv" ? "sv-SE" : "en-US")} kr</span>
            <span>{max.toLocaleString(locale === "sv" ? "sv-SE" : "en-US")} kr</span>
          </div>
        </div>

        <div className="flex justify-end">
          <CommonButton
            text={t("common_words.applyToday")}
            bgColor="#B3594D"
            textColor="#EDD2B9"
            className="large-button"
            svgImages={<ButtonRightArrow size={20} color="#EDD2B9" />}
            onClick={handleButtonClick}
          />
        </div>
      </div>
    </div>
  );
};

export default LoanCalculator;
